import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import Cookies from 'universal-cookie';
const UploadTheaterForm = ({
  theater, 
  region,
  area,
  user_id
}) => {
  const [ file, setFile ] = useState(null)
  const [ page, setPage ] = useState('uploading')
  const [ loading, setLoading ] = useState(false)
  const [ errors, setErrors ] = useState([])
  const [ processResponse, setProcessResponse ] = useState(null)
  
  const onDrop = (files) => { 
    const newFile = files[0]
    //chekc if new file is a excel file
    if (newFile.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      alert("You must upload a Excel file.")
      return
    }
    console.log("file", newFile)
    setFile(newFile)
  }

  const renderDropzone = () => {
    return (
      <>
      <Dropzone  onDrop={onDrop}>
        
        {({getRootProps, getInputProps}) => (
          <>
          <div className="upload-container">
          
          <section id="drop-area">
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <div class="upload-text">
              <div class="upload-logo">
                <i class={loading ? "fa fa-spinner fa-pulse" :"fa fa-arrow-down"}></i>
                </div>
                <div class="upload-details"></div>
                <div class="btn secondary">{file ? `Replace file ${file.name}` : 'Select file to upload'}</div>
              </div>
            </div>
          </section>
          </div>
          </>
        )}
      </Dropzone>
      <div>
        <button onClick={uploadFile} type="submit" name="commit" value="" class="btn primary float-right" data-disable-with="Upload Award Details"> Upload Award Details</button>
        <div class="btn secondary float-right" onClick={cancel}>Cancel</div>
      </div>
      </>
    )
  }

  const cancel = () => {
    setPage('uploading')
    setFile(null)
    setErrors([])
    setProcessResponse(null)
    $('#upload-theater-award-modal').toggleClass('suppressed')
  }

  const renderInner = () => {
    if(loading) {
      return (
        <div class="loading">Loading...</div>
      )
    }
    switch(page) {
      case 'review':
        return renderReview()
      default:
        return renderDropzone()
    }
  }


  const renderReview = () => {
    console.log("processResponse", processResponse)
    const { upload } = processResponse
    
    return (
      <div>
        <h2> Awards Can Be Uploaded: {upload?.metadata?.successful_award_count} </h2>
        <span>These awards can be uploaded upon confirmation.</span>

        <h2>  Award with Errors: {upload?.metadata?.failed_award_count} </h2>
        <h2> Please review before submitting: </h2>
        <div className="review-table-container">
        <table className="table review-table">
          <tr>
            {upload?.metadata?.columns.map((column, index) => {
              return (
                <th>{column['Label']}</th>
              )
            })}
           </tr>
          {upload?.metadata?.spreadsheet.map((row, index) => 
            renderRow(row, index)
          )}
        </table>
        </div>
        <div>
          <button onClick={finalizeSubmission} type="submit" name="commit" value="" class="btn primary float-right" data-disable-with="Upload Award Details"> 
            Submit {upload?.metadata?.successful_award_count} Awards
          </button>
          <div class="btn secondary float-right" onClick={cancel}>Cancel</div>
        </div>
      </div>
    )
  }

  const renderRow = (row) => {
    const isErroringRow = row.findIndex((column) => {return column['error']}) > -1
    return (
      <tr className={isErroringRow ? "row-error" : "row-success"}>
        {(row||[]).map((column, index) => {
          return (
            <td className={`${column['error'] ? "cell-error" : ""}`}>
              {`${column['value']}`||"[Empty]"}
              {column['error'] && (
                <div className="cell-error-message">
                  <b>Error:</b>{column['error']}
                </div>
              )}
            
            </td>
          )
        })}
      </tr>
    )
  }

  const finalizeSubmission = () => {
    const { upload } = processResponse
    setLoading(true)
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    fetch(`/engraving/theater-awards/finalize_upload/${upload.id}`, {
      method: 'POST',
      headers : {
        "X-CSRF-Token": token,
      }
    }).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
        if((data.error || data.errors || []).length > 0) {
          setErrors(data.error || data.errors)
          setLoading(false)
          setPage('uploading')
        }else {
          setErrors([])
          //Reload the page to get the new data
          window.location.reload();
        }
      })
    }})
  }
  

  const uploadFile = () => {
    if(!file) {
      alert("You must upload a file.")
      return
    }
    setLoading(true)
    const formData = new FormData();
    formData.append('file', file);
    
    const cookies = new Cookies();
    const token = cookies.get("X-CSRF-Token");
    formData.append('user_id', user_id);
    fetch(` /engraving/theater-awards/upload/${region.id}/${theater}${area ? `/${area}` : ""}`, {
      method: 'POST',
      body: formData,
      headers : {
        "X-CSRF-Token": token,
      }
    }).then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          if((data.error || data.errors || []).length > 0) {
            setErrors(data.error || data.errors)
            setLoading(false)
            setPage('uploading')
          }else {
            setProcessResponse(data.process_response)
            setErrors([])
            setLoading(false)
            setPage('review')

          }

        })
      }
    })
  }

  const renderError = () => {
    if(errors.length > 0) {
      return (
        <div class="">
          <ul>
            {errors.map((error) => {
              return (
                <li>{error}</li>
              )
            })}
          </ul>
        </div>
      )
    }
  }
  return (
    <div>
      {renderError()}
      {renderInner()}
      
    </div>
  )
}

export default UploadTheaterForm